import {envAwarePost} from '../../util/util'

import {useSelector} from 'react-redux'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'

export default function CrashLogging(){
	const {show,debugData} = useSelector(
		state => state.crashLogging
	)
	const reloadPage = ()=>{
		window.location.reload()
	}
	const report = ()=>{
		envAwarePost('/api/errors/',{
			action:'reportWebError',
			data:JSON.stringify(debugData)
		})
		reloadPage()
	}
	return (
		<Modal show={show} onHide={()=>{}}>
			<Modal.Header>
				<Modal.Title>
					<i className="fas fa-exclamation-triangle mr-1"/>
					We detected an issue.
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="warning" className="text-dark">
					Something isn't working right. To help us fix the issue click the "report" button. This will notify developers and send diagnostic data.
				</Alert>
			</Modal.Body>
			<Modal.Footer className='d-flex'>
				<Button 
					variant="outline-secondary"
					onClick={reloadPage}
				>
					Reload Page
				</Button>
				<Button 
					variant="outline-primary"
					onClick={report}
				>
					Report Issue & Reload Page (recommended)
				</Button>
			</Modal.Footer>
		</Modal>
	)
}